import { tokens, Loader } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${tokens.color.ui_background};
  height: calc(100vh - 54px);
`;

export const SetupWizardLoader = (): JSX.Element => {
  return (
    <Wrapper>
      <Loader isLoading size="xl" />
    </Wrapper>
  );
};
